<p>dummy-register-page works!</p>
